import { render, staticRenderFns } from "./ActiveComment.vue?vue&type=template&id=88efba40"
import script from "./ActiveComment.vue?vue&type=script&lang=js"
export * from "./ActiveComment.vue?vue&type=script&lang=js"
import style0 from "./ActiveComment.vue?vue&type=style&index=0&id=88efba40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports